import axios from 'axios';
axios.defaults.timeout = 10000;

const listAllExperience = async (filter, key = '', offset) => {
  console.log('Filter: ', filter);
  const apiUrl = process.env.VUE_APP_API_URL;
  const blogs = await axios
    .get(
      `${apiUrl}/v1/public/experience-nepal?filter=${filter}&q=${key}&offset=${offset}`
    )
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });
  return blogs;
};

const showExperienceDetail = async (id) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const blogDetail = await axios
    .get(`${apiUrl}/v1/public/experience-nepal/${id}`)
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });

  return blogDetail;
};
export default {
  listAllExperience,
  showExperienceDetail,
};
